module.exports = __webpack_public_path__ + "static/assets/6b7920398988a8a2413c2c6653fb04fa.png";